import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOpbouw = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M17.65 16.18H5.45v.89h12.2zM29.22 23.67H5.45v.89h23.77z"
    />
    <path
      fill="#B3E9B1"
      d="M14.47 31.16V9.58h-.89v21.58z"
    />
    <path
      fill="#60D15D"
      d="M30.11 24.56H14.48v6.6h15.63zM13.59 24.56H4.57v6.6h9.02zM13.59 9.58H4.57v6.6h9.02zM20.2 17.07H4.57v6.6H20.2z"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m18.53 9.5-.06 15.81a.65.65 0 0 0 1 .6l12.63-6.27a.66.66 0 0 0 .1-1.12L19.59 9a.66.66 0 0 0-1.06.5"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m30.402 18.388-5.47 2.71-.444-.896 5.47-2.71z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M32.074 17.198a2.04 2.04 0 0 0-2.728-.927 2.04 2.04 0 0 0-.92 2.731l3.968 8.022a2.037 2.037 0 0 0 2.729.927 2.04 2.04 0 0 0 .92-2.731z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOpbouw);

export default ForwardRef;
